module.exports = __webpack_public_path__ + "img/baodan@2x.02051386.png";